import * as React from "react";
const SvgBenefitsOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M4 17v2h16v-2zM4 6h2.2a1.4 1.4 0 0 1-.163-.475A3.5 3.5 0 0 1 6 5q0-1.25.875-2.125A2.9 2.9 0 0 1 9 2q.75 0 1.387.388.638.387 1.113.962L12 4l.5-.65q.45-.6 1.1-.975T15 2q1.25 0 2.125.875T18 5q0 .274-.038.525-.037.25-.162.475H20q.824 0 1.413.588Q22 7.175 22 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6m0 8h16V8h-5.1l1.5 2.05q.25.35.2.737a.9.9 0 0 1-.4.638.97.97 0 0 1-.737.188.98.98 0 0 1-.638-.388L12 7.4l-2.825 3.825a.98.98 0 0 1-.638.388.97.97 0 0 1-.737-.188.95.95 0 0 1-.412-.638.97.97 0 0 1 .187-.737L9.05 8H4zm5-8q.424 0 .713-.287A.97.97 0 0 0 10 5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 9 4a.97.97 0 0 0-.713.287A.97.97 0 0 0 8 5q0 .424.287.713Q8.576 6 9 6m6 0q.424 0 .713-.287A.97.97 0 0 0 16 5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 15 4a.97.97 0 0 0-.713.287A.97.97 0 0 0 14 5q0 .424.287.713Q14.576 6 15 6"
    />
  </svg>
);
export default SvgBenefitsOutlined;
